
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop3=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Introduction',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile">STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In the scenario where you are transitioning directly from a Computer Science and Engineering (CSE) undergraduate program to a CSE master's program without any job experience, the emphasis in your Statement of Purpose (SOP) can be on academic achievements, research interests, and your passion for the field.
                </p>


           
                 <p> <strong>Why this Course - Key Emphasis Section </strong> </p>
                 <p></p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of: </strong> 
                  <br></br>
                  <strong>Avoid Ambiguity:</strong> Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                 <p> <strong>Steer Clear of Clichés:</strong>  Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                  This section is an opportunity to showcase your academic and, if applicable, professional journey. Detail your academic achievements, focusing on relevant courses or projects that have prepared you for the desired program. If you have work experience, highlight how it has contributed to your skills and knowledge. In the case of extracurricular activities, emphasize those that demonstrate skills applicable to the academic and professional world.
                
                </p>
               <p><strong>Mistakes that need to be taken care of: </strong>
                </p>
              <p><strong>Irrelevant Details:</strong></p>
                <p>While providing your background, stay focused on elements that directly contribute to your suitability for the program. Avoid unnecessary details.</p>
                <h6> <strong>Overemphasis on Grades:</strong></h6>
                <p> While academic achievements are important, balance the discussion with other aspects of your background to present a holistic picture.</p>
               

     
                
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class=" martop" role="alert">
  
      
<p><strong>Why this Course - Key Emphasis Section </strong></p>
<p><strong>What to Include:  </strong></p>
<p><strong>Academic Achievements: </strong>Here, elaborate on why you are specifically interested in the course you are applying for. Discuss specific aspects of the curriculum that align with your academic and career goals. Go beyond a surface-level description; delve into the unique features, specializations, or projects that attracted you to this course.     </p>

        <p>
        {/* <p>  <strong>Mistakes that need to be taken care of: </strong>      </p>   */}

        <p><strong>Research Interests: </strong></p>
        Discuss any specific areas of research or topics within CSE that you are passionate about. If you have engaged in any independent projects or research during your undergraduate studies, mention them and how they have influenced your decision to pursue further education.
        </p>
        <p><strong>Alignment with Program Curriculum: </strong>  Explain how the master's program's curriculum aligns with your academic interests and career goals. Mention specific courses, specializations, or faculty members whose work you find particularly inspiring or relevant to your ambitions.</p>
      
        
<p><strong>Neglecting Skills Enhancement: </strong>
  Clearly explain how the course will enhance your skills and contribute to your professional development.
</p>
<p><strong>Contributions to the Academic Community: </strong>   If you've been involved in any academic or extracurricular activities related to CSE during your undergraduate years, briefly mention them. This could include participating in coding competitions, hackathons, or contributing to open-source projects.</p>
<p><strong>Technology or Tools Familiarity: </strong>If applicable, discuss any specific technologies, programming languages, or tools you are familiar with. Emphasize how your existing skills will serve as a strong foundation for the master's program.</p>
<p><strong>How to Pen It:  </strong></p>
<p>Begin by expressing your enthusiasm for the field of Computer Science and Engineering and briefly mention key academic achievements during your undergraduate studies.</p>
<p>Discuss any research interests or projects you have undertaken, emphasizing the depth of your passion for the subject and showcasing your willingness to engage in academic exploration.</p>
<p>Articulate your reasons for pursuing a master's degree, emphasizing the unique aspects of the program at [University]. Mention specific features of the curriculum, faculty expertise, or research opportunities that align with your academic interests.</p>
<p>If you have a familiarity with specific technologies or tools, mention them and highlight how this knowledge will contribute to your success in the master's program.</p>
<p></p>
<p>Conclude by summarizing your commitment to academic excellence in the field of CSE, and express your eagerness to contribute to and learn from the academic community at [University].</p>
     

     <p><strong>Example:  </strong></p>
     <p>Throughout my undergraduate journey in Computer Science and Engineering, I have consistently strived for academic excellence, with a particular focus on [specific areas of study or projects]. These experiences have not only honed my technical skills but have also fueled my passion for [specific aspects of CSE]. I am particularly drawn to the Master's program at [University] due to its robust curriculum, which includes [mention specific courses or specializations] that perfectly align with my academic interests. My exposure to [specific technologies or tools] during my undergraduate studies has equipped me with a solid foundation, and I am eager to further enhance my skills in this dynamic field. Although I do not have direct job experience, my commitment to academic exploration and a desire to contribute to the academic community make me a dedicated and motivated candidate for this program. I look forward to immersing myself in the vibrant academic environment at [University], where I hope to not only expand my knowledge but also contribute meaningfully to the field of Computer Science and Engineering</p>
        <hr></hr>
        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Career Goals  </strong>
                  </p>  
                  <p><strong>Explanation: </strong></p>
                  <li>
                  In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.
                  </li>
                <p><strong>Mistakes that need to be taken care of: </strong></p>
                <p>Vagueness: Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.</p>
                <p><strong>Contradictions:  </strong>Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.</p>


        </>,
      },
      {
        title: 'Second',
        content: <>
      <p   style={{marginTop: '10px',}}><strong>Why this University: </strong>This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name. </p>
       
       <p><strong>Mistakes that need to be taken care of: </strong></p>
      

       <p><strong>Generic Praise:</strong> Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
     
       <p> <strong>Lack of Personalization: </strong> Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.</p>    
      

       <p><strong>Conclusion: </strong> Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.</p>
       <p><strong>Mistakes that need to be taken care of:</strong></p>
       <p><strong>Introducing New Information:</strong> The conclusion is not the place for new information. Stick to summarizing what you've already discussed</p>
       <p><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.</p>
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop3;
